import { ListApplicationPage } from '@/modules/applications/pages/ListApplicationsPage';
import { ApplicationsSearchParams } from '@/modules/applications/types';
import { AdminLayout } from '@/modules/common/layouts/AdminLayout';
import { ApplicationStage, ApplicationTerm } from '@/types/application';
import { createFileRoute } from '@tanstack/react-router';
import * as yup from 'yup';

export const Route = createFileRoute('/_admin/applications/')({
  validateSearch: (
    search: Record<string, unknown>,
  ): ApplicationsSearchParams => {
    return {
      page: yup.number().integer().min(1).optional().validateSync(search.page),
      limit: yup
        .number()
        .integer()
        .min(1)
        .optional()
        .validateSync(search.limit),
      applicationStage: yup
        .string()
        .oneOf(Object.values(ApplicationStage))
        .optional()
        .validateSync(search.applicationStage),
      applicationTerm: yup
        .string()
        .oneOf([...Object.values(ApplicationTerm), 'LEARNING_BUDGET'])
        .optional()
        .validateSync(search.applicationTerm),
      term: yup.string().optional().validateSync(search.term),
    };
  },
  component: () => {
    return (
      <AdminLayout>
        <ListApplicationPage />
      </AdminLayout>
    );
  },
});
